import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsLetterModalService {

  private selectedNewsLetterSubject = new BehaviorSubject<any>(null);
  public selectedNewsLetter$ = this.selectedNewsLetterSubject.asObservable();

  constructor() { }

  setSelectedNewsLetter(newsLetter: any): void {
    this.selectedNewsLetterSubject.next(newsLetter);
  }

  getSelectedNewsLetter(): any | null {
    return this.selectedNewsLetterSubject.value;
  }

  clearSelectedNewsLetter(): void {
    this.selectedNewsLetterSubject.next(null);
  }
}

